import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { IRosterOpsHost } from './roster-member-ops.service';
import { RosterMemberService } from './roster-member.service';

export interface IRosterSearchHost extends IRosterOpsHost {
  filterRoster: any;
  rosterSearch: boolean;
  clear: boolean;
  filterInput: boolean;
  sortType: string;
  queryType: string;
  sortEmailIcon: string;
  sortLastNameIcon: string;
  rosterSortType: string;
}

@Injectable({ providedIn: 'root' })
export class RosterSearchService {

  constructor(private rosterMemberService: RosterMemberService) {}

  // ── sort roster members via API ────────────────────────────────────────────

  sortRoaster(sType: string, qType = 'last_name_order', host: IRosterSearchHost): void {
    host.sortType = sType;
    host.queryType = qType;
    host.rosterSearch = true;
    this.rosterMemberService.sortMembers(host.id, host.roasterdefaultCounter, host.queryType, host.sortType)
      .pipe(takeUntil(host.destroy$)).subscribe((sortedList: any) => {
        setTimeout(() => { host.rosterSearch = false; }, 1000);
        host.teamsData.members = sortedList.members;
        if (host.queryType === 'email_order') {
          host.sortEmailIcon = host.sortType;
        } else if (host.queryType === 'last_name_order') {
          host.sortLastNameIcon = host.sortType;
        } else {
          host.rosterSortType = host.sortType;
        }
      });
  }

  // ── roster filter / search function ───────────────────────────────────────

  async searchRoaster(value: any, showHide: boolean, clear = false, host: IRosterSearchHost): Promise<void> {
    host.filterInput = showHide;
    if (value !== '') host.clear = true;
    if (!value) host.filterData = '';
    if (clear) {
      setTimeout(() => {
        host.filterData = '';
        host.filterRoster = '';
        host.clear = false;
      }, 100);
    }
    if (value?.length > 2 && !clear) {
      host.rosterSearch = true;
      host.clear = false;
      this.rosterMemberService.searchMembers(host.id, host.roasterdefaultCounter, host.searchby, value)
        .pipe(takeUntil(host.destroy$)).subscribe((res: any) => {
          if (res?.members?.length) {
            host.filterData = host.searchby === 'search'
              ? this.rosterMemberService.fuzzySearchMembers(res.members, value)
              : res.members;
          } else {
            host.filterData = 'Member not Found';
            host.rosterSearch = false;
          }
          host.clear = true;
          setTimeout(() => {
            if (host.selectedFilterMbr) {
              host.filterData?.map((item) => {
                const match = host.selectedFilterMbr.find((obj) => obj.id === item.id);
                if (match) { item['checked'] = true; }
              });
            }
            host.rosterSearch = false;
          }, 500);
        });
    } else {
      host.clear = true;
      host.rosterSearch = false;
    }
  }
}
